export default {"src":"/_next/static/media/xby.52cb4bf7.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};